export default __webpack_public_path__ + "static/media/Pencil.ddca45b5.svg";